// extracted by mini-css-extract-plugin
module.exports = {"tooltipContent":"style_tooltipContent__3-w62"};